export const STATIC_DOCUMENTATION_IDS = {
  FLEX_TROUBLESHOOTING_GUIDE: '89d7456f-2c16-45c2-9985-bf860704c367',
  TEST_POINT_INSTALLATION_INSTRUCTIONS: '432a75ec-631d-4160-b8cf-22f725ca08d8',
  WHITE_LISTING_GUIDANCE: 'b923c131-99af-459b-b340-e89c83d2df27',
  EMAIL_RETRIEVAL_CONFIGURATION_GUIDANCE: '96e8db7c-d972-4c47-a58f-de1921747fac',
  WAF_TESTING_GUIDANCE: '81faa43b-e6de-4b40-bc2f-15b0b3c817e1'
};

/**
 * Asset-job type ids. `/v1/asset_jobs` identifies the job to run by id, so these are the handles for
 * the agent operations the UI can trigger.
 */
export const ASSET_JOB_IDS = {
  /** Collect an agent's full log bundle, for download or upload to AttackIQ. */
  LOGFILE_GET_ALL: '13247f31-4545-4c13-a59f-90d3c26c6b99'
};

export const UNIFIED_MITIGATION_TYPE_IDS = {
  SIGMA: 1,
  YARA: 2,
  SNORT: 3,
  SPLUNK_SPL: 8,
  KQL_MICROSOFT_SENTINEL: 9,
  ELASTIC_EQL_DSL: 10,
  QRADAR_AQL: 11,
  CHRONICLE_YARA_L: 12,
  SURICATA: 13,
  ZEEK: 14,
  OSQUERY: 15,
  WAZUH: 16,
  XQL_CORTEX: 17,
  CQL_CROWDSTRIKE: 18,
  LEQL_RAPID7: 19,
  SPOTTER_SNYPR: 20,
  POWERQUERY_SENTINELONE: 21
};

// Connectors
export const LOG_RHYTHM_CONNECTOR_ID = 'd30fe89b-0d8c-4bab-99fb-71900646bdc1';

export const DEVO_CONNECTOR_ID = '65e14c71-88b5-47ee-8d44-84287c0ba3e5';

export const SNYPYR_CONNECTOR_ID = 'b489c9af-41ec-4582-8a95-39854809ca00';

export const QRADAR_CONNECTOR_ID = '817fc9b4-9ef5-47c0-a555-6efb70e18cc2';

export const HUNTERS_SOC_CONNECTOR_ID = 'f539cf58-d4c8-4b3b-aa59-a0d596ba1a2f';

export const EXABEAM_FUSION_CONNECTOR_ID = '29891e70-ecba-4f3c-a731-35469cec9daa';

export const AWS_CLOUDWATCH_CONNECTOR_ID = 'fec529dc-613a-4840-b1a3-a4377b10e3a1';

export const SINGULARITY_AI_SIEM_CONNECTOR_ID = 'db984abb-06a1-4e7d-a0f5-45b27a0aa84c';

export const CORTEX_XSIAM_CONNECTOR_ID_LEGACY = '808aa3b8-3c03-4b44-870a-3a3f8f8ec662';

export const CORTEX_XSIAM_CONNECTOR_ID = '5d915bef-6d9b-4ca7-b13f-84d6c8f7fc58';

export const CROWDSTRIKE_FALCON_CONNECTOR_ID = 'c4d4d838-3cbb-4571-8eea-032f72b7da95';

export const SENTINEL_CONNECTOR_ID = '7466ecd5-00a9-49a2-a278-3c03a91a1fe9';

export const GOOGLE_CHRONICLE_CONNECTOR_ID = '4bf2dc6c-2687-4673-8f6d-615c89159b8c';

export const SPLUNK_ES_CONNECTOR_ID = '9318d040-8a27-4477-8720-5272f8873e6a';

export const SPLUNK_CONNECTOR_ID = 'e2f5c80d-163e-4f16-aab4-8356214a220e';

export const SIEM_FORWARDER_CONNECTOR_ID = '0f57a5a8-41ad-4612-9b18-3c9c5c79bf2c';

export const ELASTIC_SIEM_CONNECTOR_ID = '29c63b62-30ab-4caa-a4ad-103921f92ee1';

export const BUSINESS_ENTITY_TAG_SET_ID = '5d3368ee-2ce6-4b1f-99e7-064bf581279d';
// End Connectors

// Connector Types
export const AGGREGATE_COLLECTOR_CONNECTOR_TYPE_ID = '8afc266f-d2d7-46c8-80de-cde94ef1dafc';

export const SINGLE_COLLECTOR_CONNECTOR_TYPE_ID = '78cd1533-3e4f-4dff-8448-4a5f9ec1e885';
// End Connector Types

/**
 * The Network vendor product domain: a vendor product tagged into it is a network security control,
 * which Ready can select as the boundary its network tests query. Duplicated in
 * `apps/vanguard/src/constants/ids.ts` and `packages/future/src/common/constants/ids.ts`.
 */
export const NETWORK_VENDOR_PRODUCT_DOMAIN_ID = 'a15b4ec3-c5a1-4535-bc1a-840a3075b6ff';

// Notification Integration Types IDs
export const ASSESSMENT_DETAILS_CSV_TYPE_ID = 'ff1686d7-dd26-4935-8dbd-b40e7911ad33';

export const AWS_TYPE_ID = 'd01ebfb7-315c-43a5-8f93-cd80e1617679';

export const EMAIL_TYPE_ID = '3860aa18-568e-46ae-be9b-6089fb611ac9';

export const JIRA_TYPE_ID = '8aae1edc-94b4-4f02-b0a1-697c5461920f';

/**
 * Recorded Future. Unlike the other notification types this one is also the CTI provider:
 * `/v1/emm/cti/providers` returns this integration instance with `meta_data` surfaced as
 * `configuration`, so it is configured through the Connect API panel, not a notification form.
 */
export const RECORDED_FUTURE_TYPE_ID = 'a3f7b2c1-d4e5-4f6a-8b9c-0d1e2f3a4b5c';

export const SERVICE_NOW_TYPE_ID = 'bc227fda-1b2c-4d86-aecd-d7a59c06bd92';

export const SLACK_TYPE_ID = '8503adda-4840-4ee0-90f2-03da67ae8b10';

export const WEBHOOK_TYPE_ID = '290c3577-c5f8-4d40-8fba-e9983fbe9966';

export const PRE_EXECUTION_NOTIFICATION_TYPE_IDS = [ASSESSMENT_DETAILS_CSV_TYPE_ID];

export const POST_EXECUTION_NOTIFICATION_TYPE_IDS = [WEBHOOK_TYPE_ID];

export const NOT_CONFIGURABLE_NOTIFICATION_TYPE_IDS = [ASSESSMENT_DETAILS_CSV_TYPE_ID, EMAIL_TYPE_ID, WEBHOOK_TYPE_ID];

/**
 * The integration types that are notification channels — the complete set (AP-22447).
 *
 * `/v1/integration_types` carries every `IntegrationType` row, and `IntegrationType` has no
 * category field, so the API cannot tell notification channels from other integrations (CTI
 * providers such as Recorded Future live there too). Enumerating the endpoint therefore renders
 * non-channels as notification providers unless they are filtered out here.
 *
 * These seven are exhaustive because the backend dispatches notifications through a hardcoded
 * per-type branch: `IntegrationFactoryClass.create` raises `Unsupported Integration Type` for
 * anything else, so a type absent from this list cannot send a notification at all.
 *
 * Nothing links the two repos, so if that factory gains an eighth branch its id must be added
 * here by hand — a real channel missing from this list is hidden with no error anywhere.
 *
 * Filter with `isNotificationIntegrationType` from `@attackiq/constants/notificationTypes`.
 */
export const NOTIFICATION_INTEGRATION_TYPE_IDS = [
  ASSESSMENT_DETAILS_CSV_TYPE_ID,
  AWS_TYPE_ID,
  EMAIL_TYPE_ID,
  JIRA_TYPE_ID,
  SERVICE_NOW_TYPE_ID,
  SLACK_TYPE_ID,
  WEBHOOK_TYPE_ID
];
// End of Notification Integration Types IDs

// System Roles
export const NOTIFICATION_SYSTEM_ROLE_ID = '4cf2bc43-a276-404e-a284-8e62bbae78ea';

export const INTEGRATION_SYSTEM_ROLE_ID = '39060ca0-c4a6-408d-a21f-96c992561440';

export const AGENT_SYSTEM_ROLE_ID = '58cb6341-3679-4d71-a093-cd90601613bd';

export const GUEST_SYSTEM_ROLE_ID = '581aeb83-fdde-4d31-bde8-73bd5ab33d1c';

export const SPECIALIST_SYSTEM_ROLE_ID = 'ee5aef72-8cca-452e-bc1a-dda73acbbec2';

export const REVIEWER_SYSTEM_ROLE_ID = 'ded2f09d-5cc8-4ed8-9e91-beae4e854551';

export const CUSTOMER_ADMIN_ROLE_ID = '17cda553-9a81-4552-b404-8e5b6422aa89';

export const SUPPORT_ADMIN_ROLE_ID = '0be71611-ed1e-43d6-a9d4-677b58ba2b82';

export const SALES_ADMIN_ROLE_ID = 'c3e8a1d2-7b4f-4a6e-9d8c-2f1b5e7a3c9d';

export const BASIC_SYSTEM_ROLE_ID = 'ea1a589d-0d29-4381-8383-21a2af51eae8';

export const DEVELOPER_SYSTEM_ROLE_ID = '729cd625-d989-4c0e-ac9e-b0f381452847';

export const POWER_USER_SYSTEM_ROLE_ID = '33314c36-9b97-4570-90af-8372220339b8';

export const MANAGER_SYSTEM_ROLE_ID = 'f0d547b5-5a64-4791-aec2-a763e1e2173d';

export const ADMINISTRATOR_SYSTEM_ROLE_ID = 'da08469b-1c93-49b1-a601-5207c8afd107';

export const READ_ONLY_ADMIN_SYSTEM_ROLE_ID = '2a8f4e6d-9b2c-4d1a-8e7f-3c5b9a4d8e2f';

export const SUPER_USER_SYSTEM_ROLE_ID = 'ab8eaa26-ea20-4bdf-a1fb-002e0f7e56f9';

export const MISSION_CONTROL_SYSTEM_ROLES = [SPECIALIST_SYSTEM_ROLE_ID, REVIEWER_SYSTEM_ROLE_ID];

export const ACCESS_MANAGER_ROLE_ID = '18ab742a-0a67-4648-b359-60c415c993d3';

export const WATCHTOWER_SYSTEM_ROLE_ID = 'a1b2c3d4-e5f6-7890-1234-567890abcdef';

export const AVA_SYSTEM_ROLE_ID = '42902077-2c88-4f5d-9447-cb3b5d5c2895';
// End System Roles

/** Modules */
// Main Entitlements
export const TRIAL_MODULE_ID = '04b522a2-3428-41e5-af87-aa9296b402ed';

export const ENTERPRISE_MODULE_ID = '67b208f0-8c18-4ba9-a72f-971adc745fad';

export const READY_MODULE_ID = 'ab608e59-9645-4767-83ec-b598ae915c90';

export const FLEX_MODULE_ID = '7c0b2243-b272-4624-84a0-f8d71508907f';

export const DEEPSURFACE_MODULE_ID = '442a7c1c-6c48-4632-afe2-e385c8a97818';

export const MAIN_MODULES = [READY_MODULE_ID, FLEX_MODULE_ID, DEEPSURFACE_MODULE_ID, ENTERPRISE_MODULE_ID];

export const AEV_MODULE_ID = 'bb4fdfcc-9e0b-48e8-9c83-a86f2a322991';

export const WATCHTOWER_MODULE_ID = '158b33ec-23a9-47da-921a-22cb13de8e3f';

export const WATCHTOWER_DEMO_MODULE_ID = '4de054b1-65b8-44f8-94db-8473e3002217';

export const EMM_MODULE_ID = '69cea8e5-412b-4eca-aa8e-18929d658858';

export const DEFENSE_OPTIMIZATION_MODULE_ID = '58144110-0f8b-425f-8eb4-42086b9e5712';

export const DETECTION_RULE_MANAGER_MODULE_ID = '749cb577-8ea0-4670-9580-c63c67129ae0';

// Flex Enhancements
export const CUSTOM_PACKAGES_MODULE_ID = '578470f9-3a1b-43b6-bf7a-2198aedf90ce';

export const BETA_CUSTOM_PACKAGES_MODULE_ID = '7888959f-13ab-4eac-b634-d62dcf855051';

export const FLEX_MONTHLY_MODULE_ID = '5a3c96b0-a7cb-497c-8d8e-3b01f22b088a';

export const FLEX_ENTERPRISE_MODULE_ID = '36377c8c-321b-4595-ad87-8233778ddf76';

export const FLEX_YEARLY_MODULE_ID = 'be288143-3cb9-405a-b38b-5eb442a2506c';

export const SIGMA_VENDOR_ID = '7f7c5774-2a04-4743-a17d-db0d1f6a9d8f';

export const FLEX_PACKAGE_RUNS_MODULE_ID = '3c48c51a-edc3-45ab-b413-bc2dcff4c04d';

export const FLAT_RATE_FLEX_MODULES = [FLEX_MONTHLY_MODULE_ID, FLEX_YEARLY_MODULE_ID];

export const FLEX_VARIANTS_MODULES = [...FLAT_RATE_FLEX_MODULES, FLEX_PACKAGE_RUNS_MODULE_ID];

export const ATOMIC_PACKAGE_CREATION_MODULE_ID = '1b61ca3c-3612-488c-9a9c-be6570101fc5';

export const FLEX_DETECTION_MODULE_ID = '985d15b0-6858-4a5c-8b8e-dc0fee30f4b5';

export const FLEX_CORE_MODULE_ID = '88dd604b-f5b7-4807-b0cb-3f046c34df96';

export const FLEX_CORE_NON_WINDOWS_MODULE_ID = '966c7621-a1f0-448b-a028-09ee95419c5b';

export const FLEX_PACKAGE_GROUPS: ReadonlySet<string> = new Set([
  FLEX_CORE_MODULE_ID,
  FLEX_CORE_NON_WINDOWS_MODULE_ID,
  FLEX_DETECTION_MODULE_ID,
  CUSTOM_PACKAGES_MODULE_ID,
  BETA_CUSTOM_PACKAGES_MODULE_ID
]);

// Enterprise Enhancements
export const BPM_MODULE_ID = 'aff4da9e-df3f-4bbb-8a62-b8dfb3b2a70a';

export const AVA_MODULE_ID = '42902077-2c88-4f5d-9447-cb3b5d5c2895';

export const ENTERPRISE_MODULES = [BPM_MODULE_ID, AVA_MODULE_ID];

// Ready Enhancements
export const READY_CUSTOM_TESTS_MODULE_ID = 'c3be0807-29c6-4206-a34e-01b375c11aa7';

export const SIEM_MODULE_ID = 'd94a7f9e-1720-4dc6-a339-1cea240f6679';

// Extra Features
export const INSIGHTS_MODULE_ID = '51eceb0c-1d7a-4ac9-9087-bff47277be1c';

export const JUPYTER_MODULE_ID = 'a1f5805a-8653-45ab-abcf-07005ab58a8d';

export const EARLY_ACCESS_SCENARIOS_MODULE_ID = '284cac44-758b-4af2-8a55-9546784332a5';

export const AGENTIC_OS_CONTENT_MODULE_ID = '1fbbdaf4-3c83-419d-9708-e70d25ceffc5';

/** Command Center master account: the company owns partner tenants and can switch between them. */
export const CC_MASTER_MODULE_ID = '6ed31d41-bd17-43eb-88c4-f56babe5802b';

/**
 * Everything the "Create a child Command Center" form may offer. A fixed product allowlist
 * (AP-21931), not derived from the acting master's grantable set: the backend still clamps the
 * request to what the master may confer, and CC-Master is never on the table — only AttackIQ may
 * grant it.
 */
export const CHILD_COMMAND_CENTER_MODULE_IDS: ReadonlySet<string> = new Set([
  AGENTIC_OS_CONTENT_MODULE_ID,
  AVA_MODULE_ID,
  ENTERPRISE_MODULE_ID,
  DEFENSE_OPTIMIZATION_MODULE_ID,
  DETECTION_RULE_MANAGER_MODULE_ID,
  EMM_MODULE_ID,
  FLEX_MODULE_ID,
  FLEX_CORE_MODULE_ID,
  FLEX_CORE_NON_WINDOWS_MODULE_ID,
  FLEX_DETECTION_MODULE_ID,
  FLEX_ENTERPRISE_MODULE_ID,
  FLEX_MONTHLY_MODULE_ID,
  FLEX_PACKAGE_RUNS_MODULE_ID,
  INSIGHTS_MODULE_ID,
  READY_MODULE_ID,
  READY_CUSTOM_TESTS_MODULE_ID,
  WATCHTOWER_MODULE_ID
]);
/* End Modules */

export const SCRIPT_EXECUTION_SCENARIO_INSTANCE_ID = 'b7b0fa6d-5f3c-44b2-b393-3a83d3d32da3';

export const COMMAND_EXECUTION_SCENARIO_INSTANCE_ID = '9edec174-908e-4fea-b63d-5303c08fc1d6';

export const PCAP_REPLAY_SCENARIO_INSTANCE_ID = '88deb044-b242-468f-a168-befc08064bfd';

/**
 * Connectors offered to Ready tenants. Kept in sync with the duplicate in
 * `apps/vanguard/src/constants/ids.ts`, which stays until Ready's Configuration > Detections is
 * absorbed into the unified Setup. This list was copied from vanguard in `15667b13f5` off a branch
 * that predated `84dc6cb226` and `20790528ba`, so it was missing VM Ware Carbon Black EDR: the two
 * lists disagreed 10-vs-11 and `useAreAllIntegrationsConfigured` therefore reported "all
 * configured" while the Add dialog still offered an eleventh option.
 */
export const READY_AVAILABLE_CONNECTORS = [
  '027fb925-6758-4714-a19a-00b13e5f147a', // BlackBerry Optics and Protect
  '89e40c05-0475-4347-b262-33f59a47b92e', // VM Ware Carbon Black EDR
  '089e4728-b752-4a01-8dd4-08046e1cc05f', // CB Cloud
  '6567dbdf-0dae-4ffa-9954-82572b8ba656', // Cisco Secure Endpoint
  '4859db12-30a2-49fa-ae65-7b4a0fb13c02', // Cisco Umbrella
  '539e6ab0-f2b5-4d70-99cb-28ca3d5f76cc', // Cortex XDR
  'b4cfd56d-cfdb-4ff2-9a70-7f68f52a76d5', // CrowdStrike Falcon
  'd4ce4b20-eac7-4676-8888-bf3ff8c9a370', // Cybereason
  '5f3d9b33-4fbe-45bc-9338-01d289273435', // Microsoft Defender for Endpoint
  '61b39fcc-ad5e-42f8-b533-a62b16fd3f6c', // PAN Panorama
  '9139ceda-171b-4734-a2eb-d8a1abff54bf' // Sentinel One
];

export const EULA_TYPES = {
  READY: 'c3d4e5f6-a7b8-9012-cdef-123456789012',
  FLEX: 'b2c3d4e5-f6a7-8901-bcde-f12345678901',
  DEEPSURFACE: 'd4e5f6a7-b8c9-0123-def0-234567890123',
  ENTERPRISE: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
  MISSION_CONTROL: 'e5f6a7b8-c9d0-1234-ef01-345678901234',
  ENTERPRISE_ON_PREMISES: '5a6e8b1e-8273-48ff-a9e2-726a1de944eb'
};
